import { apiClient } from './client';

export const smilepassportApi = {
  getAll: (params) => apiClient.get('/smilepassports', { params }),
  getById: (id) => apiClient.get(`/smilepassports/${id}`),
  getByChild: (childId) => apiClient.get(`/smilepassports/child/${childId}`),
  getByEvent: (eventId) => apiClient.get(`/smilepassports/event/${eventId}`),
  getByEventAndChild: (eventId, childId) => apiClient.get(`/smilepassports/event/${eventId}/child/${childId}`),
  create: (data) => apiClient.post('/smilepassports', data),
  update: (id, data) => apiClient.put(`/smilepassports/${id}`, data),
  delete: (id) => apiClient.delete(`/smilepassports/${id}`),
  publish: (id, payload) => apiClient.post(`/smilepassports/${id}/publish`, payload),
};
